import { render, staticRenderFns } from "./app.vue.js?vue&type=template&id=1916333c&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=template&id=1916333c&vue3"
import script from "./app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=script&lang=js&vue3"
export * from "./app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports